export const routes = {
  dashboard: '/',
  documents: '/documents',
  document: '/documents/:id',
  timeline: '/timeline',
  tasks: '/tasks',
  task: '/tasks/:id',
  area: '/areas/:category',
  settings: '/settings',
  subscription: '/settings/plan',
  chat: '/settings/chat',
  onboarding: '/onboarding',
  survey: '/surveys/:tag',
} as const

export function documentRoute(id: string): string {
  return routes.document.replace(':id', id)
}

export function taskRoute(id: string): string {
  return routes.task.replace(':id', id)
}

export function areaRoute(category: string): string {
  return routes.area.replace(':category', category)
}

export function surveyRoute(tag: string): string {
  return routes.survey.replace(':tag', tag)
}

const deepLinks: Record<string, string> = {
  dashboard: routes.dashboard,
  documents: routes.documents,
  timeline: routes.timeline,
  roadmap: routes.timeline,
  tasks: routes.tasks,
  settings: routes.settings,
  plan: routes.subscription,
  chat: routes.chat,
  onboarding: routes.onboarding,
}

const nested: Record<string, (id: string) => string> = {
  document: documentRoute,
  task: taskRoute,
  area: areaRoute,
  survey: surveyRoute,
}

export function routeOfStartParam(startParam: string | undefined): string | undefined {
  if (!startParam) {
    return undefined
  }

  const [name, id] = startParam.split('_')

  if (name && id && nested[name]) {
    return nested[name](id)
  }

  return name ? deepLinks[name] : undefined
}
